import { REPLY_TYPE } from '@/utils/responseHandler';
import { TFE_NODE_TYPE, ALL_BOT_TYPE } from '@/utils/constants';
import getRecommenderUIOptimisationGroup from '@/utils/experiment/getRecommenderUIOptimisation';
import firstInitStore from '@/stores/firstInit';
import { isBank } from '@/config/core';

const firstDialogueWhiteList = [
  REPLY_TYPE.MSG,
  REPLY_TYPE.ARTICLE,
  REPLY_TYPE.TFE_ARTICLE,
  REPLY_TYPE.TFE_MESSAGE,
  REPLY_TYPE.KEY_ANSWER,
  REPLY_TYPE.EXPEDITE_DELIVERY_CARD,
];
const lastDialogueWhiteList = [
  REPLY_TYPE.NEW_HOT_QUESTION,
  REPLY_TYPE.TFE_RELATED_INTENT,
  REPLY_TYPE.INTENT_CLARIFICATION,
  REPLY_TYPE.TFE_OPTION_SELECTOR,
];

// 判断 rcmd 是否需要 使用 UI Optimisation
export const useUIOptimisationRecommender = (replies: any[], res: any) => {
  if (!getRecommenderUIOptimisationGroup()) {
    // 不在实验内的不使用
    return false;
  }
  if (!isBank() && (firstInitStore?.initStore?.botType !== ALL_BOT_TYPE.INTENT_BASE_BOT) && (res?.bot_type !== ALL_BOT_TYPE.INTENT_BASE_BOT)) {
    // 不是 buyer bot 的就不使用
    return false;
  }

  if (replies && replies?.length === 1 && replies[0]?.reply_type === REPLY_TYPE.KEY_ANSWER) {
    // 单独 key answer 内置的 faq 需要使用
    return true;
  }

  if (replies && replies?.length === 1 && (replies[0]?.reply_type === REPLY_TYPE.ARTICLE || replies[0]?.reply_type === REPLY_TYPE.TFE_ARTICLE)) {
    // article 也有内置的 faq 需要使用
    return true;
  }

  if (!Array.isArray(replies) || !replies?.length || replies?.length < 2) {
    // 其余的 需要两个以上才符合提交
    return false;
  }

  // let firstIndex = -1, lastIndex = -1;
  // for(let i = replies.length - 1; i >= 0; i--) {
  //   const item = replies[i];
  //   if(lastIndex === -1 && lastDialogueWhiteList.includes(item.reply_type)) {
  //     lastIndex = i;
  //   } else if (lastIndex > -1 && firstDialogueWhiteList.includes(item.reply_type) || (item.reply_type === REPLY_TYPE.MSG && item.message?.is_rich_text)) {
  //     firstIndex = i;
  //     break;
  //   }
  // }


  // 找出 符合的 dialogue
  let firstReplyNodeListLastIndex = -1;
  const firstReplyNodeList = [];
  // 符合前面的 dialogue 可能有多个
  for (let i = 0, len = replies?.length; i < len; i++) {
    const item = replies[i];
    if (lastDialogueWhiteList.includes(item.reply_type)) {
      // 有出现 end 节点 后面的就不用管了
      break;
    }
    // 如果是  msg 需要是 富文本
    if (firstDialogueWhiteList.includes(item.reply_type)) {
      firstReplyNodeList.push(item);
      firstReplyNodeListLastIndex = i;
    }
  }
  if (!firstReplyNodeList?.length) {
    return false;
  }
  // 最后一个 dialogue 只有一个 且从  firstReplyNode 最后一个开始查找起
  const lastIndex = replies?.findIndex((x, idx) => {
    return idx > firstReplyNodeListLastIndex && lastDialogueWhiteList.includes(x.reply_type);
  });
  if (lastIndex === -1) {
    return false;
  }

  const lastReplyNode = replies?.[lastIndex] ?? {};

  // 如果是 label 澄清 需要判断前面是不是有  某个节点是 answer 节点 又是 end 节点
  if (lastReplyNode?.reply_type === REPLY_TYPE.TFE_OPTION_SELECTOR) {
    for (let i = 0; i < lastIndex; i++) {
      const item = replies[i];
      if (isEndAndAnswerNode(item)) {
        return true;
      }
    }
    return false;
  }

  return true;
};

// 是否是 end 节点和 answer 节点
const isEndAndAnswerNode = (node: any) => {
  let data: null | any = null;
  switch (node?.reply_type) {
    case REPLY_TYPE.TFE_MESSAGE:
      data = node?.message_extra?.task_flow_text;
      break;
    case REPLY_TYPE.KEY_ANSWER:
      data = {
        task_bot_info: node?.message_extra?.task_bot_info,
        is_end: node?.message_extra?.task_flow_is_end,
      };
      break;
    case REPLY_TYPE.TFE_ARTICLE:
      data = node?.message_extra?.task_flow_article;
      break;
    case REPLY_TYPE.TFE_BUTTON_SELECTOR:
      data = node?.message_extra?.task_flow_button_selector;
      break;
    case REPLY_TYPE.TFE_CARD_SELECTION:
      data = node?.message_extra?.task_flow_card;
      break;
    case REPLY_TYPE.TFE_RELATED_INTENT:
      data = node?.message_extra?.task_flow_related_intent;
      break;
    case REPLY_TYPE.TFE_MODAL:
      data = node?.message_extra?.task_flow_popup;
      break;
    case REPLY_TYPE.TFE_OPTION_SELECTOR:
      data = node?.message_extra?.task_flow_option_selector;
      break;
    case REPLY_TYPE.TFE_ORDER_TIP_MSG:
      data = node?.message_extra?.task_flow_click_text_reply;
      break;
    case REPLY_TYPE.TFE_ORDER_SELECTION_FAQ:
      data = node?.message_extra?.task_flow_faq_list_reply;
      break;
    case REPLY_TYPE.TFE_EPOD_IMAGE:
      data = node?.message_extra?.task_flow_image;
      break;
    case REPLY_TYPE.TFE_TIMELINE_CARD:
      data = node?.message_extra?.task_flow_timeline_card_reply;
      break;
    case REPLY_TYPE.TFE_BUYER_ORDER:
      data = node?.message_extra?.task_flow_food_buyer_order_card;
      break;
    case REPLY_TYPE.TFE_BUYER_ORDER_LIST:
      data = node?.message_extra?.task_flow_food_buyer_order_card_selector;
      break;
    case REPLY_TYPE.TFE_CONTACT_COURIER_CARD:
      data = node?.message_extra?.task_flow_key_courier_card;
      break;
    default:
      break;
  }
  if (!data) {
    return false;
  }

  return data?.is_end && data?.task_bot_info?.node_type === TFE_NODE_TYPE.ANSWER_NODE;
};
